// extracted by mini-css-extract-plugin
export default {"ribbon":"Ribbon_ribbon__7xix-","label":"Ribbon_label__z+Ypi"};